var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-dialog', {
    attrs: {
      "width": "500px"
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on,
            attrs = _ref.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_vm._v("취소 사유 설정")])];
      }
    }]),
    model: {
      value: _vm.shows,
      callback: function callback($$v) {
        _vm.shows = $$v;
      },
      expression: "shows"
    }
  }, [_c('v-card', [_c('v-row', {
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "5"
    }
  }, [_c('v-card-title', [_vm._v("취소 사유 설정")])], 1), _c('v-col', {
    staticClass: "d-flex align-center justify-end mr-4"
  }, [_c('cancel-reasons-create-dialog', {
    on: {
      "update": _vm.update
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on,
            attrs = _ref2.attrs;
        return [_c('v-btn', _vm._g(_vm._b({
          attrs: {
            "icon": "",
            "text": "",
            "color": "primary"
          }
        }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-plus")])], 1)];
      }
    }])
  })], 1)], 1), _c('v-divider'), _c('v-card-text', [_c('v-row', [_c('v-data-table', {
    attrs: {
      "items": _vm.form,
      "headers": _vm.itemHeaders,
      "disable-sort": ""
    },
    scopedSlots: _vm._u([{
      key: "item.actions",
      fn: function fn(_ref3) {
        var item = _ref3.item,
            index = _ref3.index;
        return [_c('cancel-reasons-create-dialog', _vm._b({
          on: {
            "update": _vm.update
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref4) {
              var on = _ref4.on,
                  attrs = _ref4.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "small": ""
                }
              }, 'v-icon', attrs, false), on), [_vm._v("mdi-pencil")])];
            }
          }], null, true)
        }, 'cancel-reasons-create-dialog', {
          value: item,
          index: index
        }, false)), _c('v-icon', {
          staticClass: "ml-1",
          attrs: {
            "small": ""
          },
          on: {
            "click": function click($event) {
              return _vm.remove(index);
            }
          }
        }, [_vm._v("mdi-delete")])];
      }
    }], null, true)
  })], 1)], 1), _c('v-divider'), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    on: {
      "click": function click() {
        return _vm.shows = false;
      }
    }
  }, [_vm._v("취소")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }